import axios from "axios";
import { logout } from "../ReduxStore/authSlice";
import showToast from "./showToast";
const BACKEND_URL = process.env.REACT_APP_BACKENDURL;
export const Axios = axios.create({
    baseURL: BACKEND_URL
})

export const NonAuthAxios = async ({ url, method, payload }) => {
    try {
        let response;
        switch (method) {
            case 'get':
                response = await axios.get(BACKEND_URL + url, {
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    mode: 'cors'
                })
                break;
            case 'post':
                if (payload === "") {
                    response = await axios.post(BACKEND_URL + url, {}, {
                        headers: { 'Content-Type': 'application/json', 'mode': 'cors' }
                    })
                } else {
                    response = await axios.post(BACKEND_URL + url, payload, {
                        headers: { 'Content-Type': 'application/json', 'mode': 'cors' }
                    })
                }
                break;
            default:
                break;

        }
        return response?.data
    } catch (error) {
        return error.response
    }
}


export const AuthAxios = async ({ url, method, payload }, dispatch) => {
    try {
        let response;
        switch (method) {
            case 'get':
                response = await axios.get(BACKEND_URL + url, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `bearer ${localStorage.getItem('_u')}`
                    },
                    mode: 'cors'
                })
                break;
            case 'post':
                if (payload === "") {
                    response = await axios.post(BACKEND_URL + url, {}, {
                        headers: { 'Content-Type': 'application/json', 'mode': 'cors', 'Authorization': `bearer ${localStorage.getItem('_u')}` }
                    })
                } else {
                    response = await axios.post(BACKEND_URL + url, payload, {
                        headers: { 'Content-Type': 'application/json', 'mode': 'cors', 'Authorization': `bearer ${localStorage.getItem('_u')}` }
                    })
                }
                break;
            default:
                break;

        }

        return response?.data

    } catch (error) {
        // console.log("error", error)
        dispatch(logout())
        if (error === null) showToast('error', 'Unrecoverable error!! Error is null!')
        if (axios.isAxiosError(error)) {
            const response = error?.response;
            if (error.code === 'ERR_NETWORK') {
                showToast('error', 'connection problem')
            } else if (error.code === 'ERR_CANCELED') {
                showToast('error', 'connection canceled..')
            }
            if (response) {
                const statusCode = response?.status
                if (statusCode === 404) {
                    showToast('error', 'The requested resource does not exist')
                }
            }
        }
        if (error.status === 440) {
            showToast('error', 'Session Expired');
        }
        if (error.status === 403) {
        }
        if (error.status === 401) {
            showToast('error', 'Un authorized');
        }
        return error.response;
    }

}

